import React from 'react';
import { useStore, useStoreActions } from "../../store/store-context";
import { useHistory, useLocation } from 'react-router-dom';
import { redirect, routes } from "../../constants";
import { AnchorLogo } from 'seagull/icons';
import { Button, Typography } from 'seagull';
import { selectors } from "../../store/state-selectors";
import styles from "./NoAccessPage.module.scss";
import ContactSupportButton from "../../components/ContactSupportButton";
import { SetLoginFlow } from "../unAuthorizedPages";
import { useOnMount } from "../../hooks/useOnMount";
const NoAccessPage = () => {
  const {
    setAuthToken
  } = useStoreActions();
  const history = useHistory();
  const location = useLocation();
  const locationState = location.state;
  const existingEmail = useStore(selectors.user.email);
  const recipientEmail = locationState === null || locationState === void 0 ? void 0 : locationState.recipientEmail;
  const returnTo = locationState === null || locationState === void 0 ? void 0 : locationState.returnTo;
  const isVendor = useStore(selectors.user.isVendor);
  const {
    logBI
  } = useStoreActions();
  const hasAuthToken = useStore(state => state.authToken != null);
  useOnMount(() => {
    if (recipientEmail) {
      logBI(15101);
    } else {
      logBI(15100);
    }
  });
  const descriptionText = recipientEmail && hasAuthToken ? /*#__PURE__*/React.createElement(React.Fragment, null, "This link is meant for ", /*#__PURE__*/React.createElement("b", null, recipientEmail), ", but you're logged in as ", /*#__PURE__*/React.createElement("b", null, existingEmail), " which does not have the necessary permissions to access this asset.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "To switch users, log out and sign in with the relevant email address. Make sure to save your work first.") : /*#__PURE__*/React.createElement(React.Fragment, null, "If you believe you should have access or require additional permissions, please contact your account owner or ", /*#__PURE__*/React.createElement(ContactSupportButton, {
    hideContactText: true,
    underline: "none",
    variant: "h5"
  }), ".");
  async function logOutUser() {
    logBI(15103);
    await setAuthToken(null);
    const setLoginFlow = isVendor ? SetLoginFlow.Full : SetLoginFlow.Simplified;
    history.replace(redirect.getPathAndSearch({
      returnTo: returnTo
    }), {
      setLoginFlow
    });
  }
  async function backToDashboard() {
    logBI(15102);
    history.replace(routes.home);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "notification-no-access-page",
    className: styles.noAccessPageContainer
  }, /*#__PURE__*/React.createElement(AnchorLogo, {
    theme: "dark",
    height: 44
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    weight: "normal",
    "data-testid": "notification-no-access-header"
  }, "You don't have permissions to access this asset"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    "data-testid": "notification-no-access-description",
    className: styles.description
  }, descriptionText), hasAuthToken && /*#__PURE__*/React.createElement("div", {
    className: styles.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    skin: recipientEmail ? 'primaryOutline' : 'primary',
    onClick: backToDashboard,
    "data-testid": "notification-no-access-back-to-dashboard-button"
  }, "Back to dashboard"), recipientEmail && /*#__PURE__*/React.createElement(Button, {
    skin: "primary",
    onClick: logOutUser,
    "data-testid": "notification-no-access-logout-button"
  }, "Log out")));
};
export default NoAccessPage;